/**
 * Empty State Component
 * 
 * @package TopBuddy
 */

import { Card, CardBody, Button } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const EmptyState = () => {
	const handleAddNew = () => {
		window.location.href = `${window.topbuddyDashboard.newPostUrl}?post_type=topbuddy_nb`;
	};

	return (
		<Card>
			<CardBody>
				<div className="topbuddy-empty-state">
					<h2>{__('No Notification Bars Yet', 'topbuddy')}</h2>
					<p>{__('Create your first notification bar to get started.', 'topbuddy')}</p>
					<Button variant="primary" onClick={handleAddNew}>
						{__('Add New Notification Bar', 'topbuddy')}
					</Button>
				</div>
			</CardBody>
		</Card>
	);
};

export default EmptyState;

